var map = {
	"./buy_normal_cn.png": "fc0e",
	"./buy_normal_en.png": "4d11",
	"./buy_normal_id.png": "2a57",
	"./buy_normal_ko.png": "d2bb",
	"./buy_normal_ph.png": "f0b5",
	"./buy_normal_th.png": "c6d2",
	"./buy_normal_zh.png": "6134"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "833d";